import { z } from "zod";

/** pg-boss job names and payloads (plan §5.3). */
export const JOBS = {
  verify: "checkpoint.verify",
  plan: "checkpoint.plan",
  imageRender: "image.render",
  linkReplay: "link.replay",
} as const;

export const VerifyJob = z.object({ checkpointId: z.string(), sessionId: z.string(), playerId: z.string() });
export type VerifyJob = z.infer<typeof VerifyJob>;

export const PlanJob = z.object({
  checkpointId: z.string().optional(),
  playerId: z.string(),
  /** Set by worker-chain after InsufficientVault: replace unsubmitted ops for this save. */
  replan: z.boolean().optional(),
  saveSeq: z.number().int().optional(),
});
export type PlanJob = z.infer<typeof PlanJob>;

export const ImageRenderJob = z.object({ asset: z.string(), saveSeq: z.number().int() });
export type ImageRenderJob = z.infer<typeof ImageRenderJob>;

export const LinkReplayJob = z.object({ linkSessionId: z.string() });
export type LinkReplayJob = z.infer<typeof LinkReplayJob>;

export const CRON_JOBS = {
  sessionTimeouts: "cron.session-timeouts",
  settleCredit: "cron.settle-credit",
  sweepFees: "cron.sweep-fees",
  releases: "cron.releases",
  reconcile: "cron.reconcile",
  sseCleanup: "cron.sse-cleanup",
  commerceReconcile: "cron.commerce-reconcile",
} as const;

export const CommerceReconcileJob = z.object({
  /** When set, only reconcile this commerce_transactions row. */
  commerceTxId: z.string().uuid().optional(),
});
export type CommerceReconcileJob = z.infer<typeof CommerceReconcileJob>;
